// extracted by mini-css-extract-plugin
export var messageSideLeft = "_r6-1";
export var stateContainer = "_r6-0";